import React, { Component } from 'react';
import { Form, FormFeedback, FormGroup, Label, Input } from 'reactstrap';
import withValidator from '../../models/form/withValidator';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    name: {
      rules: [
        {
          feedback: 'Name is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    timezone: {
      rules: [
        {
          feedback: 'Timezone is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class MyDepartmentDetailsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        name: '',
        timezone: '',
      },
      errorFeedback: {},
      name: !this.props.initialValues ? '' : this.props.initialValues.name,
      timezone: !this.props.initialValues
        ? ''
        : this.props.initialValues.timezone,
      isFormDisabled: true,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        name: this.state.name,
        timezone: this.state.timezone,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: nextProps.hasErrors || nextProps.hasUntouched,
    });
  }

  // ----------------------
  // Handlers
  // ----------------------

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      name: this.state.name,
      timezone: this.state.timezone,
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <FormGroup>
          <Label for="name">
            Name <i className="fa fa-asterisk" />
          </Label>
          <Input
            className={this.state.cssValidationClasses.name}
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="text"
            name="name"
            id="name"
            value={this.state.name}
          />
          <FormFeedback>{this.state.errorFeedback.name}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="timezone">
            Time Zone <i className="fa fa-asterisk" />
          </Label>
          <Input
            className={this.state.cssValidationClasses.timezone}
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="select"
            name="timezone"
            id="timezone"
            value={this.state.timezone}
          >
            <option value="America/Anchorage">Alaska Time Zone</option>
            <option value="America/Chicago">Central Time Zone</option>
            <option value="America/New_York">Eastern Time Zone</option>
            <option value="Pacific/Honolulu">Hawaii Time Zone</option>
            <option value="America/Denver">Mountain Time Zone</option>
            <option value="America/Phoenix">
              Mountain/Pacific Time Zone (Arizona)
            </option>
            <option value="America/Los_Angeles">Pacific Time Zone</option>
          </Input>
          <FormFeedback>{this.state.errorFeedback.timezone}</FormFeedback>
        </FormGroup>
        <div className="text-right">
          <button
            className="button primary"
            disabled={this.state.isFormDisabled}
          >
            Submit
          </button>
        </div>
      </Form>
    );
  }
}

export default withValidator(MyDepartmentDetailsForm, validatorConfig);
